import { useCallback } from 'react';
import utils from '../utils/utils';

const usePhoneNumberInput = (onChange) => {
	return useCallback(
		(e) => {
			const input = e.target;
			const { name } = input;
			let { value } = input;
			const cursorPos = input.selectionStart;

			if (utils.invalidPhoneCharactersRegex.test(value)) {
				value = value.replace(utils.invalidPhoneCharactersRegex, '');
			}

			if (value.length > 12) {
				e.preventDefault();
				return;
			}

			const digitsBeforeCursor = value.slice(0, cursorPos).replace(/\D/g, '').length;
			const formatted = utils.formatPhoneNumber(value);
			const newCursorPos = utils.getFormattedPhoneCursorPosition(formatted, digitsBeforeCursor);

			onChange(name, formatted);
			requestAnimationFrame(() => input.setSelectionRange(newCursorPos, newCursorPos));
		},
		[onChange]
	);
};

export default usePhoneNumberInput;
